import { Badge } from 'avo-ui'
import { Link } from 'react-router-dom'
import { formatDateMoment, setNumberWithPoint } from 'utils/utils'

export const TABLE_USER = {
    name: 'Users',
    column: [
        {
            name: 'User',
            key: 'user',
            render: ({ item }) => (
                <Link
                    to={`/user/user-list/user-detail?userId=${item?.id}`}
                    className={'flex flex-row gap-3 items-center'}
                >
                    <img className={'w-7 h-7 rounded-full'} src={item?.profile_picture} alt={item?.name} />
                    <p className={'capitalize font-medium text-blue-90 hover:font-bold hover:underline'}>
                        {item?.name}
                    </p>
                </Link>
            ),
        },
        {
            name: 'Email',
            key: 'email',
        },
        {
            name: 'Total Point',
            key: 'total_point',
            render: ({ value }) => <div>{setNumberWithPoint(value)}</div>,
        },
        {
            name: 'Role',
            key: 'role',
            className: 'capitalize',
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD-MM-YYYY')}</div>,
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'created_at',
    order_type: 'desc',
}

export const SORT_USER = [
    {
        label: 'Sort By Name Desc',
        key: 'name-desc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Name Asc',
        key: 'name-asc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Date Desc',
        key: 'created_at-asc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Date Asc',
        key: 'created_at-desc',
        name: 'sort-user',
    },
]

export const FILTER_PARAMS = ['role_ids', 'status', 'membership_status']

export const FILTER_USER = [
    {
        title: 'role',
        key: 'role_ids',
        list: [],
    },
    {
        title: 'status',
        key: 'status',
        list: [
            {
                name: 'active',
                value: 'active',
            },
            {
                name: 'inactive',
                value: 'inactive',
            },
        ],
    },
    {
        title: 'membership',
        key: 'membership_status',
        list: [
            {
                name: 'membership',
                value: 'membership',
            },
            {
                name: 'Non Membership',
                value: 'non-membership',
            },
        ],
    },
]

export const INIT_STATUS = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'Inactive',
        value: 'inactive',
    },
    {
        label: 'Delete',
        value: 'delete',
    },
]
